module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst entityContext = (config || {}).entityContext || 'product'\nconst additionalClasses = []\nif(config.usage)        additionalClasses.push(`usage_${config.usage}`);\nif(config.usageMode)    additionalClasses.push(`usageMode_${config.usageMode}`);\nconst exportGranted = helpers.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'mblx')\nconst requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx')\nvar tooltips = config.tooltips || {};\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<section class=\"main\">\n<%\nif(config.usageMode === 'choose') {\n%>\n<section class=\"left\">\n<%- helpers.renderSection('filter'); %>\n<%\nif(tooltips.NW){\n%><%- include('../../../base/tooltip/tooltip', { model: tooltips.NW, config: { additionalClasses: 'NW' } }); %><%\n}\nif(tooltips.N){\n%><%- include('../../../base/tooltip/tooltip', { model: tooltips.N, config: { additionalClasses: 'N' } }); %><%\n}\nif(tooltips.NE){\n%><%- include('../../../base/tooltip/tooltip', { model: tooltips.NE, config: { additionalClasses: 'NE' }  }); %><%\n}\n%>\n<%- helpers.renderSection('list'); %>\n</section>\n<section class=\"right\">\n<%- helpers.renderSection('content'); %>\n</section>\n<%\n} else {\n%>\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %><%\nif(exportGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }); %><%\n}\nif(config.usage !== 'selection'){\nif(requestProductAdditionalInformationGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductsAdditionalInformation', symbolOnly: false } }); %><%\n}\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }); %><%\n}\n%>\n</section>\n</section>\n<%\nif(tooltips.NW){\n%><%- include('../../../base/tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter'); %>\n<%- helpers.renderSection('list'); %>\n</section>\n<%\n}\n%>\n</section>\n<%- helpers.renderSection('selection'); %>\n</div>"
  , __filename = "components/templates/mblx/products/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const entityContext = (config || {}).entityContext || 'product'
const additionalClasses = []
if(config.usage)        additionalClasses.push(`usage_${config.usage}`);
if(config.usageMode)    additionalClasses.push(`usageMode_${config.usageMode}`);
const exportGranted = helpers.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'mblx')
const requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx')
var tooltips = config.tooltips || {};

    ; __line = 9
    ; __append("\n<div class=\"")
    ; __line = 10
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<section class=\"main\">\n")
    ; __line = 12
    ; 
if(config.usageMode === 'choose') {

    ; __line = 14
    ; __append("\n<section class=\"left\">\n")
    ; __line = 16
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 17
    ; 
if(tooltips.NW){

    ; __line = 19
    ; __append( include('../../../base/tooltip/tooltip', { model: tooltips.NW, config: { additionalClasses: 'NW' } }) )
    ; 
}
if(tooltips.N){

    ; __line = 22
    ; __append( include('../../../base/tooltip/tooltip', { model: tooltips.N, config: { additionalClasses: 'N' } }) )
    ; 
}
if(tooltips.NE){

    ; __line = 25
    ; __append( include('../../../base/tooltip/tooltip', { model: tooltips.NE, config: { additionalClasses: 'NE' }  }) )
    ; 
}

    ; __line = 27
    ; __append("\n")
    ; __line = 28
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n<section class=\"right\">\n")
    ; __line = 31
    ; __append( helpers.renderSection('content') )
    ; __append("\n</section>\n")
    ; __line = 33
    ; 
} else {

    ; __line = 35
    ; __append("\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 38
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 42
    ; 

    ; __line = 43
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; 
if(exportGranted){

    ; __line = 45
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }) )
    ; 
}
if(config.usage !== 'selection'){
if(requestProductAdditionalInformationGranted){

    ; __line = 49
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductsAdditionalInformation', symbolOnly: false } }) )
    ; 
}

    ; __line = 51
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }) )
    ; 
}

    ; __line = 53
    ; __append("\n</section>\n</section>\n")
    ; __line = 56
    ; 
if(tooltips.NW){

    ; __line = 58
    ; __append( include('../../../base/tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 60
    ; __append("\n<section class=\"bottom\">\n")
    ; __line = 62
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 63
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n")
    ; __line = 65
    ; 
}

    ; __line = 67
    ; __append("\n</section>\n")
    ; __line = 69
    ; __append( helpers.renderSection('selection') )
    ; __append("\n</div>")
    ; __line = 70
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/controller.ejs

}